import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import * as i18n from "util/i18n";

export const useTags = (optionEcheq) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { echeqFilters } = useSelector((state) => state.echecks);

    const commonTagOptions = {
        createdFrom: { id: "createdRange", text: i18n.get("echecks.createdRange.label") },
        payedFrom: { id: "payedRange", text: i18n.get("echecks.payedRange.label") },
        ownership: { id: "ownership", text: i18n.get("echecks.ownership.label") },
        status: { id: "status", text: i18n.get("echecks.status.label") },
        number: { id: "number", text: i18n.get("echecks.number.label") },
        grouper: { id: "grouper", text: i18n.get("echecks.grouper.label") },
        id: { id: "id", text: i18n.get("echecks.id.label") },
    };

    const tagOptions = {
        "received.echeqs": {
            ...commonTagOptions,
            receiver: { id: "receiver", text: i18n.get("echecks.receiver.label") },
        },
        "emitted.echeqs": {
            ...commonTagOptions,
            emitted: { id: "emitted", text: i18n.get("echecks.emitted.label") },
        },
    };

    useEffect(() => {
        const activeTags = Object.entries(echeqFilters)
            .filter(
                (activeFilters) =>
                    !activeFilters.includes("") && !activeFilters.includes("TODOS") && !activeFilters.includes(null),
            )
            .map((filter) => filter[0])
            .filter((filterKey) => !!tagOptions[optionEcheq][filterKey])
            .map((key) => tagOptions[optionEcheq][key]);

        setTags(activeTags);
    }, [echeqFilters]);

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;

        if (
            deletedFilter !== "createdRange" &&
            deletedFilter !== "payedRange" &&
            deletedFilter !== "status" &&
            deletedFilter !== "ownership"
        ) {
            const tagFilters = {
                ...echeqFilters,
                [deletedFilter]: "",
            };
            dispatch(echeckActions.setEcheqFilters(tagFilters));
            dispatch(echeckActions.filterEcheqList(tagFilters));
            return;
        }

        if (deletedFilter === "createdRange") {
            const tagFilters = {
                ...echeqFilters,
                createdFrom: null,
                createdTo: null,
            };
            dispatch(echeckActions.setEcheqFilters(tagFilters));
            dispatch(echeckActions.filterEcheqList(tagFilters));
            return;
        }

        if (deletedFilter === "payedRange") {
            const tagFilters = {
                ...echeqFilters,
                payedFrom: null,
                payedTo: null,
            };
            dispatch(echeckActions.setEcheqFilters(tagFilters));
            dispatch(echeckActions.filterEcheqList(tagFilters));
            return;
        }

        if (deletedFilter === "status") {
            const tagFilters = {
                ...echeqFilters,
                status: "TODOS",
            };
            dispatch(echeckActions.setEcheqFilters(tagFilters));
            dispatch(echeckActions.filterEcheqList(tagFilters));
            return;
        }

        if (deletedFilter === "ownership") {
            const tagFilters = {
                ...echeqFilters,
                ownership: "TODOS",
            };
            dispatch(echeckActions.setEcheqFilters(tagFilters));
            dispatch(echeckActions.filterEcheqList(tagFilters));
        }
    };

    const handleCleanFilters = () => {
        const clearFilters = {
            ...echeqFilters,
            createdFrom: null,
            createdTo: null,
            payedFrom: null,
            payedTo: null,
            receiver: "",
            emitted: "",
            ownership: "TODOS",
            status: "TODOS",
            number: "",
            grouper: "",
            id: "",
        };
        dispatch(echeckActions.setEcheqFilters(clearFilters));
        dispatch(echeckActions.filterEcheqList(clearFilters));
    };

    return { tags, handleDelete, handleCleanFilters };
};

export default useTags;
